import { createApp } from 'vue'
import App from './App.vue'
import { setDocumentLocale } from '@/i18n'
import { sanitizeSentryBreadcrumb, sanitizeSentryEvent } from '@/utils/onboardingTelemetry'
const app = createApp(App)
setDocumentLocale()

import '@/assets/style/normalize.css'
import '@/assets/style/reset.css'

import router from '@/router'
import store from '@/store'

import vue3GoogleLogin from 'vue3-google-login'

import { Quasar, Notify, Dialog } from 'quasar'
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import * as Sentry from '@sentry/vue'

const isSentryInit = import.meta.env.VITE_SENTRY_INIT //get env VITE_SENTRY_INIT

// gen ju env init sentry
if (isSentryInit != 'false') {
  Sentry.init({
    app,
    dsn: 'https://e6024b2e5c804f53a950c7ccb5406445@o4504580912119808.ingest.sentry.io/4505119896764416',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: 0.3,
    beforeSend: sanitizeSentryEvent,
    beforeBreadcrumb: sanitizeSentryBreadcrumb
  })
}

//vue3-google-login
app.use(vue3GoogleLogin, {
  clientId: import.meta.env.VITE_CLIENT_ID
})

//import router
app.use(router)
//import store
app.use(store)

app.use(Quasar, {
  plugins: { Notify, Dialog } // import Quasar plugins and add here
})

app.mount('#app')
